import React from 'react';

import { styled } from '@mui/material/styles'

import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LabelIcon from '@mui/icons-material/Label';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import { Field } from '../states/settingState';

type Props = {
  open: boolean;
  currentActId: string;
  currentFieldId: string;
  fields?: Field[];
  handleCommit: (fieldId: string, actId: string) => void;
  handleClose: () => void;
};

const FieldListItem = styled(ListItemButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(0),
}));

export const FieldUpdateMoveActDialog: React.FC<Props> = (props) => {

  const handleSelectField = (fieldId) => {
    props.handleCommit(fieldId, props.currentActId);
  };

  const createField = (level: number, f: Field) => {
    const disabled = (f.id === props.currentFieldId);

    return (
      <FieldListItem key={`catalog-${f.id}-${level}`} disabled={disabled} onClick={() => handleSelectField(f.id)}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={f.name} />
      </FieldListItem>
    );
  }

  const fTree = (level: number, fs: Field[], view: React.JSX.Element[]) => {
    fs.forEach((f, index) => {
      if (f.id === '9999') return;
      view.push((
        <Paper key={`catalogs-${level}-${f.id}`}
         sx={{
            minWidth: 275,
            margin: 1,
          }} elevation={3}>
          <List>
            {createField(level, f)}
          </List>
        </Paper>
      ));
    });
  };

  const createFields = () => {
    const view: React.JSX.Element[] = [];
    if (props.fields && Array.isArray(props.fields)) {
      fTree(0, props.fields, view);
    }

    return (
      <>
        {view}
      </>
    )
  };

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"選択した分野の最後尾に文書を移動します"}</DialogTitle>
      <DialogContent>
        {createFields()}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );

};
